import React from 'react';
import { Title } from 'components/commons';
import ShareUrl from 'components/share-url';
import { SITE_URL } from 'env';
import getValue from 'lodash/get';
import { formatMoney, getLoanApplicationParams } from 'utils/utils';
import { useGetLoanQuery } from 'generated/graphql';

const ShareAntiFraudUrl: React.FC = (): JSX.Element => {
    const loanApplicationId = getLoanApplicationParams();

    const { data } = useGetLoanQuery({
        variables:{
            id:loanApplicationId
        },
        fetchPolicy:"cache-first"
    });

    const amountRequested = formatMoney(getValue(data, 'loanApplication.acceptedProposal.amount', 0));

    return (
        <div className="l-documents-screen grid-container">
            <div className="l-documents-screen__content">
                <Title className="mb-4">
                    Compartilhe o link abaixo com sua indicação para ela seguir no processo Biz
                </Title>

                <p className="body-1 mb-4">
                    A partir daqui apenas o contato indicado poderá finalizar o processo de identificação e envio de documentos.
                </p>

                <div className="l-documents-screen__box">
                    <div className="l-documents-screen__invitation">
                        <h3 className="bold mb-3">
                            Envie para sua indicação o link abaixo
                        </h3>

                        <p className="body-2 lg:body-1 mb-5">
                            Após enviar confira se seu contato recebeu e conseguiu acessar o link.
                        </p>

                        <ShareUrl
                            url={`${SITE_URL}/pedido/${loanApplicationId}`}
                            whatsappMessage={`Olá, você foi indicado por nosso parceiro para receber um empréstimo de R$ ${amountRequested} na Bizcapital. Pediremos que você envie foto do seu documento de identificação e documentos para completar o cadastro da proposta. Entre no link a seguir para iniciar o processo: ${SITE_URL}/pedido/${loanApplicationId}`}
                        />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ShareAntiFraudUrl;
